import { attachConsentChangeListener, purposesToFlags } from '@/Utils/PrivacyUtility';
import TestsDataStorage from '@/Utils/TestsDataStorage';

function createConsentManager() {
    let flags = 0;
    const scripts = [];

    function updateTestsStorage() {
        TestsDataStorage.setItem('registeredScripts', scripts.map(e => e.name));
        TestsDataStorage.setItem('loadedScripts', scripts.filter(e => e.loaded).map(e => e.name));
    }

    function tryLoad(entry) {
        if (entry.loaded) return;
        if (entry.requires && !(flags & entry.requires)) return;
        entry.load();
        entry.loaded = true;
    }

    function updateConsent(newFlags) {
        flags = newFlags;
        scripts.forEach(tryLoad);
        updateTestsStorage();
    }

    attachConsentChangeListener(({ purposes }) => {
        updateConsent(purposesToFlags(purposes));
    });

    return {
        register(name, requires, loadFn) {
            const entry = { name, requires, load: loadFn, loaded: false };
            scripts.push(entry);
            tryLoad(entry);
            updateTestsStorage();
        },
    };
}

export const consentManager = createConsentManager();
